// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Jost:wght@300;400;500;600;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Jost', sans-serif;
}

.flex-1 {
    flex: 1 1;
}

.radius {
    border-radius: 25px !important;
}

.radius-20 {
    border-radius: 20px !important;
}

.blue {
    background: #2680EB !important
}

.green {
    background: #9ED523 !important
}

.gray {
    background: #F1F1F1 !important
}

.dark-gray {
    background: #ececec !important
}

.btn-completed {
    background: #9ED523;
    color: #fff;
    border-color: #9ED523;
}

.btn-completed:hover {
    background: #9ED523;
    color: #fff;
    border-color: #9ED523;
}

.btn-white {
    background: #fff;
    color: #000;
    border-color: #fff;
}

.btn-white:hover {
    background: #f1f1f1;
    color: #000;
    border-color: #f1f1f1;
}

.btn-outter-line {
    border: 1px solid #000;
}

.btn-outter-line:hover {
    border: 1px solid #000;
}

.btn-nostyle {
    border: 0;
    background: none;
    padding: 0;
}

.btn-video,
.btn-video:hover {
    background: #FFF;
    color: #2680EB;
    line-height: 20px;
}

.btn-dashboard {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 2px solid #414141;
    border-radius: 27px;
    text-align: center;
    justify-content: center;
    min-width: 160px;
}

.btn .icon {
    font-size: 14px;
    margin-right: 7px;
}

.white {
    background: #fff;
}

.dark-blue {
    background: #185094;
}

.border-darker-blue {
    border-color: #114798 !important;
}

.darker-blue {
    background-color: #001D48;
}

.orange {
    background-color: #FFA824;
}

.dark-green {
    background-color: #3BB54A;
}

.text-black {
    color: #000;
}

.text-orange {
    color: #FFA824;
}

.text-white {
    color: #fff;
}

.text-green {
    color: #3BB54A;
}

.text-blue {
    color: #2680EB;
}

.text-dark-blue {
    color: #023378;
}

.text-dark-gray {
    color: #515151;
}

.text-lite-gray {
    color: #999;
}

.font-10 {
    font-size: 10px !important;
}

.font-11 {
    font-size: 11px !important;
}

.font-12 {
    font-size: 12px !important;
}

.font-13 {
    font-size: 13px !important;
}

.font-14 {
    font-size: 14px !important;
}

.font-15 {
    font-size: 15px !important;
}

.font-16 {
    font-size: 16px !important;
}

.font-17 {
    font-size: 17px !important;
}

.font-18 {
    font-size: 18px !important;
}

.font-19 {
    font-size: 19px !important;
}

.font-20 {
    font-size: 20px !important;
}

.font-22 {
    font-size: 22px !important;
}

.font-24 {
    font-size: 24px !important;
}

.font-26 {
    font-size: 26px !important;
}

.font-28 {
    font-size: 28px;
}

.font-30 {
    font-size: 30px;
}

.font-32 {
    font-size: 32px;
}

.font-34 {
    font-size: 34px;
}

.font-36 {
    font-size: 36px;
}

.font-100 {
    font-weight: 100
}

.font-200 {
    font-weight: 200
}

.font-300 {
    font-weight: 300
}

.font-400 {
    font-weight: 400
}

.font-500 {
    font-weight: 500;
}

.font-600 {
    font-weight: 600;
}

.font-700 {
    font-weight: 700;
}
.font-900 {
    font-weight: 900;
}

body {
    background: #F5F5F5;
    background-size: cover;
}

.max-700{max-width: 800px;width: 90%;}
.main-wrapper {    height: 100vh;position: relative;}
.strip {position: absolute;left: 0;right: 0;top: 0;height: 4px;display: flex;}
.strip i {width: 20%;background: #51499C;}
.strip i + i{background: #26A7DF;}
.strip i + i + i{background: #D42941;}
.strip i + i + i + i{background: #F05A2A;}
.strip i + i + i + i +i{background: #F8B018;}

.rate_container {box-shadow: 0px 0px 10px 0px #92929259;}
.experienceboxheading {background: #0B3454;border-radius: 4px 4px 0 0;padding: 20px;position: relative;overflow: hidden;}
.experienceboxheading:before {content: '';position: absolute;top: 0;bottom: 0;left: 0;width: 131px;}
.experienceboxheading::after {content: '';position: absolute;top: 0;bottom: 0;right: 0;width: 84px;}
.experienceboxheading h3 {font-size: 30px;line-height: 40px;margin-bottom: 0px;text-align: center;color: #fff;position: relative;}
.experienceboxheading p {font-size: 16px;line-height: 23px;text-align: center;color: #fff;margin: 0;position: relative;}
.experiencebox {background: #fff;border-radius: 0 0 4px 4px;position: relative;box-shadow: 0px 0px 50px #0000001A;}

.half-gray {position: relative;}
.half-gray:before {content: '';position: absolute;left: 0;bottom: 0;top: 0;width: 50.5%;background: #F3F3F3;border-radius: 6px 0px 0px 6px;}
.half-gray > div {position: relative;}

.messages {flex: 1 1;display: flex;flex-direction: column;}
.leftUser {align-items: end;}
.leftUser p {background: #2296C9;border-radius: 10px 10px 0px 10px;padding: 7px 20px;color: #fff;margin-bottom: 10px;}
.rightUser {align-items: start;}
.rightUser p {background: #413A7D 0% 0% no-repeat padding-box;border-radius: 10px 10px 10px 0px;opacity: 1;padding: 7px 20px;color: #fff;margin-bottom: 10px;}
.conversation .userimg {display: flex;align-items: start;vertical-align: top;}
.conversation {height: 310px;overflow-y: scroll;overflow-x: hidden;margin-right: -8px;}

 /* width */
.conversation{overflow-y: scroll;scrollbar-width: thin;}
.conversation::-webkit-scrollbar {width: 3px;}
/* Track */
.conversation::-webkit-scrollbar-track {background: #f1f1f1;}

/* Handle */
.conversation::-webkit-scrollbar-thumb {background: #888;}

/* Handle on hover */
.conversation::-webkit-scrollbar-thumb:hover {background: #555;} 


@media (max-width: 575px) {
.experienceboxheading h3 {font-size: 22px;}
.modal-content.half-gray {border: 0;}
.modal-header.conversation-header {padding: 0;}
.modal-header.conversation-header .left-col {padding: 15px 20px;background: #413a7d;}
.modal-header.conversation-header .left-col .text-dark-blue {color: #fff;}
.modal-header.conversation-header .right-col {padding: 15px 20px;background: #2296c9;}
.modal-header.conversation-header .right-col .text-dark-blue {color: #fff;}
}`, "",{"version":3,"sources":["webpack://./src/styles/css/valuable_conversation.css"],"names":[],"mappings":"AACA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IAKI,SAAO;AACX;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,UAAU;AACd;;AAEA;;IAEI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA,SAAS,gBAAgB,CAAC,UAAU,CAAC;AACrC,mBAAmB,aAAa,CAAC,kBAAkB,CAAC;AACpD,QAAQ,kBAAkB,CAAC,OAAO,CAAC,QAAQ,CAAC,MAAM,CAAC,WAAW,CAAmF,aAAa,CAAC;AAC/J,UAAU,UAAU,CAAC,mBAAmB,CAAC;AACzC,aAAa,mBAAmB,CAAC;AACjC,iBAAiB,mBAAmB,CAAC;AACrC,qBAAqB,mBAAmB,CAAC;AACzC,wBAAwB,mBAAmB,CAAC;;AAE5C,iBAAiB,sCAAsC,CAAC;AACxD,uBAAuB,mBAAmB,CAAC,0BAA0B,CAAC,aAAa,CAAC,kBAAkB,CAAC,gBAAgB,CAAC;AACxH,8BAA8B,WAAW,CAAC,kBAAkB,CAAC,MAAM,CAAC,SAAS,CAAC,OAAO,CAAC,YAAY,CAAC;AACnG,8BAA8B,WAAW,CAAC,kBAAkB,CAAC,MAAM,CAAC,SAAS,CAAC,QAAQ,CAAC,WAAW,CAAC;AACnG,0BAA0B,eAAe,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,WAAW,CAAC,kBAAkB,CAAC;AACjI,yBAAyB,eAAe,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,WAAW,CAAC,SAAS,CAAC,kBAAkB,CAAC;AACvH,gBAAgB,gBAAgB,CAAC,0BAA0B,CAAC,kBAAkB,CAAC,kCAAkC,CAAC;;AAElH,YAAY,kBAAkB,CAAC;AAC/B,mBAAmB,WAAW,CAAC,kBAAkB,CAAC,OAAO,CAAC,SAAS,CAAC,MAAM,CAAC,YAAY,CAAC,mBAAmB,CAAC,8BAA8B,CAAC;AAC3I,kBAAkB,kBAAkB,CAAC;;AAErC,WAAW,SAAO,CAAC,aAAa,CAAC,sBAAsB,CAAC;AACxD,WAAW,gBAAgB,CAAC;AAC5B,aAAa,mBAAmB,CAAC,iCAAiC,CAAC,iBAAiB,CAAC,WAAW,CAAC,mBAAmB,CAAC;AACrH,YAAY,kBAAkB,CAAC;AAC/B,cAAc,+CAA+C,CAAC,iCAAiC,CAAC,UAAU,CAAC,iBAAiB,CAAC,WAAW,CAAC,mBAAmB,CAAC;AAC7J,wBAAwB,aAAa,CAAC,kBAAkB,CAAC,mBAAmB,CAAC;AAC7E,eAAe,aAAa,CAAC,kBAAkB,CAAC,kBAAkB,CAAC,kBAAkB,CAAC;;CAErF,UAAU;AACX,cAAc,kBAAkB,CAAC,qBAAqB,CAAC;AACvD,kCAAkC,UAAU,CAAC;AAC7C,UAAU;AACV,wCAAwC,mBAAmB,CAAC;;AAE5D,WAAW;AACX,wCAAwC,gBAAgB,CAAC;;AAEzD,oBAAoB;AACpB,8CAA8C,gBAAgB,CAAC;;;AAG/D;AACA,0BAA0B,eAAe,CAAC;AAC1C,0BAA0B,SAAS,CAAC;AACpC,mCAAmC,UAAU,CAAC;AAC9C,6CAA6C,kBAAkB,CAAC,mBAAmB,CAAC;AACpF,6DAA6D,WAAW,CAAC;AACzE,8CAA8C,kBAAkB,CAAC,mBAAmB,CAAC;AACrF,8DAA8D,WAAW,CAAC;AAC1E","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Jost:wght@300;400;500;600;700;900&display=swap');\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-family: 'Jost', sans-serif;\n}\n\n.flex-1 {\n    -webkit-box-flex: 1;\n    -moz-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n\n.radius {\n    border-radius: 25px !important;\n}\n\n.radius-20 {\n    border-radius: 20px !important;\n}\n\n.blue {\n    background: #2680EB !important\n}\n\n.green {\n    background: #9ED523 !important\n}\n\n.gray {\n    background: #F1F1F1 !important\n}\n\n.dark-gray {\n    background: #ececec !important\n}\n\n.btn-completed {\n    background: #9ED523;\n    color: #fff;\n    border-color: #9ED523;\n}\n\n.btn-completed:hover {\n    background: #9ED523;\n    color: #fff;\n    border-color: #9ED523;\n}\n\n.btn-white {\n    background: #fff;\n    color: #000;\n    border-color: #fff;\n}\n\n.btn-white:hover {\n    background: #f1f1f1;\n    color: #000;\n    border-color: #f1f1f1;\n}\n\n.btn-outter-line {\n    border: 1px solid #000;\n}\n\n.btn-outter-line:hover {\n    border: 1px solid #000;\n}\n\n.btn-nostyle {\n    border: 0;\n    background: none;\n    padding: 0;\n}\n\n.btn-video,\n.btn-video:hover {\n    background: #FFF;\n    color: #2680EB;\n    line-height: 20px;\n}\n\n.btn-dashboard {\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    border: 2px solid #414141;\n    border-radius: 27px;\n    text-align: center;\n    justify-content: center;\n    min-width: 160px;\n}\n\n.btn .icon {\n    font-size: 14px;\n    margin-right: 7px;\n}\n\n.white {\n    background: #fff;\n}\n\n.dark-blue {\n    background: #185094;\n}\n\n.border-darker-blue {\n    border-color: #114798 !important;\n}\n\n.darker-blue {\n    background-color: #001D48;\n}\n\n.orange {\n    background-color: #FFA824;\n}\n\n.dark-green {\n    background-color: #3BB54A;\n}\n\n.text-black {\n    color: #000;\n}\n\n.text-orange {\n    color: #FFA824;\n}\n\n.text-white {\n    color: #fff;\n}\n\n.text-green {\n    color: #3BB54A;\n}\n\n.text-blue {\n    color: #2680EB;\n}\n\n.text-dark-blue {\n    color: #023378;\n}\n\n.text-dark-gray {\n    color: #515151;\n}\n\n.text-lite-gray {\n    color: #999;\n}\n\n.font-10 {\n    font-size: 10px !important;\n}\n\n.font-11 {\n    font-size: 11px !important;\n}\n\n.font-12 {\n    font-size: 12px !important;\n}\n\n.font-13 {\n    font-size: 13px !important;\n}\n\n.font-14 {\n    font-size: 14px !important;\n}\n\n.font-15 {\n    font-size: 15px !important;\n}\n\n.font-16 {\n    font-size: 16px !important;\n}\n\n.font-17 {\n    font-size: 17px !important;\n}\n\n.font-18 {\n    font-size: 18px !important;\n}\n\n.font-19 {\n    font-size: 19px !important;\n}\n\n.font-20 {\n    font-size: 20px !important;\n}\n\n.font-22 {\n    font-size: 22px !important;\n}\n\n.font-24 {\n    font-size: 24px !important;\n}\n\n.font-26 {\n    font-size: 26px !important;\n}\n\n.font-28 {\n    font-size: 28px;\n}\n\n.font-30 {\n    font-size: 30px;\n}\n\n.font-32 {\n    font-size: 32px;\n}\n\n.font-34 {\n    font-size: 34px;\n}\n\n.font-36 {\n    font-size: 36px;\n}\n\n.font-100 {\n    font-weight: 100\n}\n\n.font-200 {\n    font-weight: 200\n}\n\n.font-300 {\n    font-weight: 300\n}\n\n.font-400 {\n    font-weight: 400\n}\n\n.font-500 {\n    font-weight: 500;\n}\n\n.font-600 {\n    font-weight: 600;\n}\n\n.font-700 {\n    font-weight: 700;\n}\n.font-900 {\n    font-weight: 900;\n}\n\nbody {\n    background: #F5F5F5;\n    background-size: cover;\n}\n\n.max-700{max-width: 800px;width: 90%;}\n.main-wrapper {    height: 100vh;position: relative;}\n.strip {position: absolute;left: 0;right: 0;top: 0;height: 4px;display: -webkit-box;display: -moz-box;display: -ms-flexbox;display: -webkit-flex;display: flex;}\n.strip i {width: 20%;background: #51499C;}\n.strip i + i{background: #26A7DF;}\n.strip i + i + i{background: #D42941;}\n.strip i + i + i + i{background: #F05A2A;}\n.strip i + i + i + i +i{background: #F8B018;}\n\n.rate_container {box-shadow: 0px 0px 10px 0px #92929259;}\n.experienceboxheading {background: #0B3454;border-radius: 4px 4px 0 0;padding: 20px;position: relative;overflow: hidden;}\n.experienceboxheading:before {content: '';position: absolute;top: 0;bottom: 0;left: 0;width: 131px;}\n.experienceboxheading::after {content: '';position: absolute;top: 0;bottom: 0;right: 0;width: 84px;}\n.experienceboxheading h3 {font-size: 30px;line-height: 40px;margin-bottom: 0px;text-align: center;color: #fff;position: relative;}\n.experienceboxheading p {font-size: 16px;line-height: 23px;text-align: center;color: #fff;margin: 0;position: relative;}\n.experiencebox {background: #fff;border-radius: 0 0 4px 4px;position: relative;box-shadow: 0px 0px 50px #0000001A;}\n\n.half-gray {position: relative;}\n.half-gray:before {content: '';position: absolute;left: 0;bottom: 0;top: 0;width: 50.5%;background: #F3F3F3;border-radius: 6px 0px 0px 6px;}\n.half-gray > div {position: relative;}\n\n.messages {flex: 1;display: flex;flex-direction: column;}\n.leftUser {align-items: end;}\n.leftUser p {background: #2296C9;border-radius: 10px 10px 0px 10px;padding: 7px 20px;color: #fff;margin-bottom: 10px;}\n.rightUser {align-items: start;}\n.rightUser p {background: #413A7D 0% 0% no-repeat padding-box;border-radius: 10px 10px 10px 0px;opacity: 1;padding: 7px 20px;color: #fff;margin-bottom: 10px;}\n.conversation .userimg {display: flex;align-items: start;vertical-align: top;}\n.conversation {height: 310px;overflow-y: scroll;overflow-x: hidden;margin-right: -8px;}\n\n /* width */\n.conversation{overflow-y: scroll;scrollbar-width: thin;}\n.conversation::-webkit-scrollbar {width: 3px;}\n/* Track */\n.conversation::-webkit-scrollbar-track {background: #f1f1f1;}\n\n/* Handle */\n.conversation::-webkit-scrollbar-thumb {background: #888;}\n\n/* Handle on hover */\n.conversation::-webkit-scrollbar-thumb:hover {background: #555;} \n\n\n@media (max-width: 575px) {\n.experienceboxheading h3 {font-size: 22px;}\n.modal-content.half-gray {border: 0;}\n.modal-header.conversation-header {padding: 0;}\n.modal-header.conversation-header .left-col {padding: 15px 20px;background: #413a7d;}\n.modal-header.conversation-header .left-col .text-dark-blue {color: #fff;}\n.modal-header.conversation-header .right-col {padding: 15px 20px;background: #2296c9;}\n.modal-header.conversation-header .right-col .text-dark-blue {color: #fff;}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
